<app-examination-submitted-popup
  [isOpen]="true"
  [isInProgress]="examResultState.status === 'IN_PROGRESS'"
  [totalAttempted]="examResultState.submissionSummary.totalAttempted"
  [totalQuestions]="examResultState.submissionSummary.totalQuestions"
  [timeTaken]="examResultState.submissionSummary.timeTaken"
  [remainingTime]="examResultState.submissionSummary.remainingTime"
  [tertiaryValue]="examResultState.submissionSummary.markedForReview"
  [unattempted]="examResultState.submissionSummary.totalUnattempted"
  [testName]="examResultState.examTitle"
  [submissionTime]="examResultState.submittedAt"
  [reviewUnlockAt]="examResultState.reviewUnlockAt !== undefined ? examResultState.reviewUnlockAt : (examResultState.expiryTimestamp ?? null)"
  [reviewLockedMessage]="examResultState.reviewLockedMessage ?? defaultReviewLockedMessage"
  (backToDashboard)="onBackToDashboard()"
  (viewResult)="onViewResult()" />
